import Swiper from 'swiper/bundle';

/**
 * Export default article slider
 */
export default () => {
  function init() {
    const target = '#meet-the-team--meet-the-team';
    new Swiper(target, {
      slidesPerView: 1,
      loop: true,
      spaceBetween: 0,
      centeredSlides: false,
      pagination: {
        el: '.swiper-pagination-mtt',
        type: 'bullets',
        clickable: 'true',
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  }

  /**
   * Return immutable object.
   */
  return Object.freeze({
    init,
  });
};
